import React, { useState, useEffect } from 'react';
import styles from "./NasaSearch.module.css";
import Nasa from '../NasaDate/Nasa';

const NasaSearch = () => {

  useEffect(() => {
    document.title = "Busca de Imagens da NASA | Fotos e Vídeos Espaciais - Fohattech";
  }, []);


// ================= API =================

async function fetchMediaFromNASA(searchQuery) {
  AtivarLoading();
  try {
    const apiUrl = `https://images-api.nasa.gov/search?q=${encodeURIComponent(searchQuery)}`;
    
    const response = await fetch(apiUrl);
    const data = await response.json();

    const imagesContainer = document.getElementById("images-container");
    imagesContainer.innerHTML = "";

    if (!isValidData(data)) {
      console.error("Nenhum resultado encontrado.");
      return;
    }

    for (const item of data.collection.items) {
      const mediaType = item.data[0].media_type;
      
      const mediaData = await fetch(item.href).then(response => response.json());
      
      const mediaUrl = getMediaUrl(mediaData, mediaType);
      const description = item.data[0].description;
      const title = item.data[0].title;

      const albumContainer = createAlbumContainer(mediaType, mediaUrl, description, title);
      imagesContainer.appendChild(albumContainer);
    }
  } catch (error) {
    console.error("Erro na API:", error);
  }
}

function isValidData(data) {
  return data && data.collection && data.collection.items && data.collection.items.length > 0;
}

function getMediaUrl(mediaData, mediaType) {
  if (mediaType === "image") {
    return findImageMediaUrl(mediaData);
  } else if (mediaType === "video") {
    return findVideoMediaUrl(mediaData);
  }
}

function findImageMediaUrl(mediaData) {
  for (const mediaUrl of mediaData) {
    if (mediaUrl.endsWith(".jpg") || mediaUrl.endsWith(".png")) {
      return mediaUrl;
    }
  }
}

function findVideoMediaUrl(mediaData) {
  for (const mediaUrl of mediaData) {
    if (mediaUrl.endsWith(".mp4")) {
      return mediaUrl;
    }
  }
}

function createAlbumContainer(mediaType, mediaUrl, description, title) {
  const albumContainer = document.createElement("div");
  albumContainer.classList.add("album");

  if (mediaType === "image") {
    const imageElement = createImageElement(mediaUrl, description);
    albumContainer.appendChild(imageElement);
  } else if (mediaType === "video") {
    const videoElement = createVideoElement(mediaUrl);
    albumContainer.appendChild(videoElement);
  }

  const titleElement = document.createElement("h2");
  titleElement.textContent = title;
  albumContainer.appendChild(titleElement);

  const ItensAfiliados = document.createElement("div");
  ItensAfiliados.classList.add("containerAFDs");
  albumContainer.appendChild(ItensAfiliados);

  return albumContainer;
}

function createImageElement(mediaUrl, description) {
  const imageElement = document.createElement("img");
  imageElement.classList.add("class-img");
  imageElement.src = mediaUrl;
  imageElement.alt = description;
  imageElement.addEventListener("click", () => openModal(mediaUrl, description));
  return imageElement;
}

function createVideoElement(mediaUrl) {
  const videoElement = document.createElement("video");
  videoElement.controls = true;
  const sourceElement = document.createElement("source");
  sourceElement.src = mediaUrl;
  sourceElement.type = "video/mp4";
  videoElement.appendChild(sourceElement);
  return videoElement;
}

function handleSearch() {
  const searchInput = document.getElementById("search-input");
  const searchQuery = searchInput.value.trim();

  if (searchQuery !== "") {
    fetchMediaFromNASA(searchQuery);
  }
}

function searchButton() {
  handleSearch();
}

// ================= MODAL =================

function openModal(mediaUrl, description) {
  const modalContainer = document.getElementById("modal-container");
  const modalImage = document.getElementById("modal-image");
  const modalDescription = document.getElementById("modal-description");

  modalImage.src = mediaUrl;
  modalDescription.textContent = description;
  modalContainer.style.display = "flex";
}

function closeModal() {
  const modalContainer = document.getElementById("modal-container");
  modalContainer.style.display = "none";
}

// ================= LOADING =================

const [isLoading, setLoading] = useState(null);

function AtivarLoading() {
  setLoading(true);
  setTimeout(() => {
    setLoading(false);
  }, 4000);
}

// ================= UI =================

return (
<>
  <div className={styles.containerNasaSearch}>

    {/* TEXTO SEO IMPORTANTE */}
    <section className={styles.infoBox}>
      <h2>Imagens oficiais da NASA em alta qualidade</h2>
      <p>
        Esta ferramenta permite acessar gratuitamente o acervo oficial de imagens
        e vídeos da NASA. Você pode encontrar fotos de planetas, estrelas, missões
        espaciais e muito mais.
      </p>

      <h3>Como usar:</h3>
      <ul>
        <li>✔ Digite um termo em inglês (ex: Mars, Space, Galaxy)</li>
        <li>✔ Clique em buscar</li>
        <li>✔ Visualize imagens e vídeos diretamente da NASA</li>
      </ul>

      <p>
        Ideal para estudantes, desenvolvedores, designers e curiosos que desejam
        explorar o universo com conteúdo confiável.
      </p>
    </section>

    {/* HEADER SEO */}
    <div className={styles.BoxTitleAndSearch}>
      <h1 className={styles.h1}>Buscar Imagens e Vídeos da NASA</h1>

      <p className={styles.subtitle}>
        Explore fotos reais do espaço, planetas, galáxias e missões da NASA.
        Busque conteúdos oficiais diretamente da base de dados da agência espacial.
      </p>

      <div className={styles.header}>
        <div className={styles.searchContainer}>
          <input
            className={styles.searchInput}
            type="text"
            id="search-input"
            placeholder="Ex: Mars, Galaxy, Earth..."
          />
          <button className={styles.searchButton} onClick={searchButton}>
            Buscar
          </button>
        </div>
      </div>
    </div>



    {/* LOADING */}
    {isLoading &&
      <div className={styles.imagesContainerLoading}>
        <div className={styles.loading}><div className={styles.loadingEsfera}></div></div>
        <div className={styles.loading}><div className={styles.loadingEsfera}></div></div>
        <div className={styles.loading}><div className={styles.loadingEsfera}></div></div>
        <div className={styles.loading}><div className={styles.loadingEsfera}></div></div>
      </div>
    }

    {/* RESULTADOS */}
    <div className={styles.imagesContainer} id="images-container"></div>

    {/* COMPONENTE EXTRA */}
    <Nasa/>

    {/* MODAL */}
    <div className={styles.modalContainer} id="modal-container">
      <span className={styles.closeModal} onClick={closeModal}>&times;</span>
      <img className={styles.modalImage} id="modal-image" src="" alt="Imagem ampliada"/>
      <p className={styles.modalDescription} id="modal-description"></p>
    </div>

  </div>
</>
)
}

export default NasaSearch;